import { ReportInterface } from '../../../interfaces/report.interface';

export class SendReport {
    public static readonly type = '[JobsPlacements] send report';

    constructor(public report: ReportInterface) {}
}
